import React from 'react';

function MentorDashboard() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Mentor Dashboard</h1>
      <div style={{ 
        background: '#f8fafc', 
        padding: '3rem', 
        borderRadius: '12px', 
        margin: '2rem 0' 
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>👨‍🏫</div>
        <h2>Welcome, Mentor!</h2>
        <p>Your mentor dashboard features are coming soon.</p>
        <p>You'll be able to manage students, create planners, review tests, and more.</p>
      </div>
    </div>
  );
}

export default MentorDashboard;